var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typeArea"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-top"},_vm._l((_vm.dataList),function(item){return _c('defaultImg',{key:item,attrs:{"src":item.src}})}),1),_c('div',{staticClass:"pagination mg-top60"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next, jumper","total":1000}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }